let Environment = {
    YfethContractAddress: "0xfE54050cC18308111438522B5c65A1cf5Ea0eC0f",
    tokenToApprove: "0xc27F02Eb14c58971D47BBa6214547E4c711A0346"
  };
  
  export default Environment;